(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-transactions-hook.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-transactions-hook.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const logger = svs.arena.logger;
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback;
const fetchTransactions = svs.arena.store.transactions.actions.fetchTransactions;
let fetchingData = false;

const useTransactions = (syndicateId, cacheLifeInSeconds) => {
  const cacheLengthInSeconds = cacheLifeInSeconds || 30;
  const dispatch = ReactRedux.useDispatch();
  const _useState = useState({
      isSuccess: false,
      isLoading: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    statusState = _useState2[0],
    setStatusState = _useState2[1];

  const loadingError = ReactRedux.useSelector(state => {
    var _state$transactions;
    return (_state$transactions = state.transactions) === null || _state$transactions === void 0 || (_state$transactions = _state$transactions[syndicateId]) === null || _state$transactions === void 0 ? void 0 : _state$transactions.error;
  }) || null;
  const transactions = ReactRedux.useSelector(state => {
    var _state$transactions2;
    return (_state$transactions2 = state.transactions) === null || _state$transactions2 === void 0 || (_state$transactions2 = _state$transactions2[syndicateId]) === null || _state$transactions2 === void 0 ? void 0 : _state$transactions2.transactions;
  }) || [];
  const hasMoreItems = ReactRedux.useSelector(state => {
    var _state$transactions3;
    return (_state$transactions3 = state.transactions) === null || _state$transactions3 === void 0 || (_state$transactions3 = _state$transactions3[syndicateId]) === null || _state$transactions3 === void 0 ? void 0 : _state$transactions3.hasMoreItems;
  }) || false;
  const latestFetch = ReactRedux.useSelector(state => {
    var _state$transactions4;
    return (_state$transactions4 = state.transactions) === null || _state$transactions4 === void 0 || (_state$transactions4 = _state$transactions4[syndicateId]) === null || _state$transactions4 === void 0 ? void 0 : _state$transactions4.latestFetch;
  }) || 0;

  const fetchData = useCallback(async () => {
    const options = {
      count: 20,
      transactionTimeUuid: null,
      syndicateId
    };
    if (fetchingData) {
      return;
    }
    fetchingData = true;
    logger.debug('useTransactionsHook: fething new data (transactions) from server');
    setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      isLoading: true
    }));
    const fetchData = await dispatch(fetchTransactions(options));
    setStatusState({
      isSuccess: RTK.isFulfilled(fetchData),
      isLoading: false
    });
    fetchingData = false;
  }, [dispatch, syndicateId]);
  React.useEffect(() => {
    const secondsSinceLastFetch = Math.round((new Date().getTime() - latestFetch) / 1000);

    if (secondsSinceLastFetch > cacheLengthInSeconds) {
      fetchData();
    } else {
      setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
        isSuccess: true
      }));
    }
  }, [cacheLengthInSeconds, fetchData, latestFetch]);
  return {
    data: transactions,
    hasMoreItems,
    isLoading: statusState.isLoading,
    isSuccess: statusState.isSuccess,
    error: loadingError
  };
};
svs.arena.shared.hooks.useTransactions = useTransactions;

 })(window);